import { initTabsBlock } from '../../src/js/tabs';
import { bootBlock } from '../../src/js/block-boot';

bootBlock('features-tabs', (root) => {
  initTabsBlock('.features-tabs', false, root);
});
